import { ColumnInterface } from '@shared/interfaces/column.interface'
import { PositionsOptionsColumnsEnum } from '../enums/positions-options-columns.enum'

export const PositionOptionsColumnsConstant: ColumnInterface<PositionsOptionsColumnsEnum>[] = [
	{
		column: PositionsOptionsColumnsEnum.option,
		visible: true,
	},
	{
		column: PositionsOptionsColumnsEnum.marketValue,
		visible: true,
	},
	{
		column: PositionsOptionsColumnsEnum.quantity,
		visible: true,
	},
	{
		column: PositionsOptionsColumnsEnum.priceAveragePrice,
		visible: true,
	},
	{
		column: PositionsOptionsColumnsEnum.share,
		visible: true,
	},
	{
		column: PositionsOptionsColumnsEnum.profitabilityPerDay,
		visible: true,
	},
	{
		column: PositionsOptionsColumnsEnum.profitability,
		visible: true,
	},
]
